export default __webpack_public_path__ + "static/media/bg_header_pod_b.ba944056.svg";